import { Directive, ElementRef, AfterViewInit, Renderer2, Input } from '@angular/core';

@Directive({
  selector: '[appAccessiblePaginator]'
})
export class AccessiblePaginatorDirective implements AfterViewInit {
  @Input() ariaLabelFirst = 'Go to first page';
  @Input() ariaLabelPrev = 'Go to previous page';
  @Input() ariaLabelNext = 'Go to next page';
  @Input() ariaLabelLast = 'Go to last page';
  

  constructor(private el: ElementRef, private renderer: Renderer2) { }

  ngAfterViewInit() {
    const firstBtn = this.el.nativeElement.querySelector('.p-paginator-first');
    const prevBtn = this.el.nativeElement.querySelector('.p-paginator-prev');
    const nextBtn = this.el.nativeElement.querySelector('.p-paginator-next');
    const lastBtn = this.el.nativeElement.querySelector('.p-paginator-last');
    if (firstBtn) {
      this.renderer.setAttribute(firstBtn, 'aria-label', this.ariaLabelFirst);
    }
    if (prevBtn) {
      this.renderer.setAttribute(prevBtn, 'aria-label', this.ariaLabelPrev);
    }
    if (nextBtn) {
      this.renderer.setAttribute(nextBtn, 'aria-label', this.ariaLabelNext);
    }
    if (lastBtn) {
      this.renderer.setAttribute(lastBtn, 'aria-label', this.ariaLabelLast);
    }
  }

}
